var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"componentRef",class:_vm.$style.component},[(_vm.imageUrl)?_c('img',{ref:"imageRef",class:_vm.$style.image,style:(Object.assign({}, _vm.size ? {
        width: _vm.pixels(_vm.size[0]),
        height: _vm.pixels(_vm.size[1])
      } : {})),attrs:{"src":_vm.imageUrl,"alt":_vm.label}}):_vm._e(),(_vm.label)?_c('div',{ref:"labelRef",class:[
      _vm.$style.label,
      _vm.labelType === 'heading' ? _vm.$style.heading : _vm.$style.body,
      _vm.$style[("size-" + _vm.labelSize)]
    ]},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }